<horizon-menubar hostAppName="Group Classes" [items]="items()" [userName]="userName()" (logout)="handleLogout()"></horizon-menubar>
